import { Progress } from "@/components/ui/progress";

type ProgressUsageProps = {
  label: string;
  used: number;
  total: number;
};

const ProgressUsage = ({ label, used, total }: ProgressUsageProps) => {
  const percentage = (used / total) * 100;
  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="font-medium">{label}</span>
          <span>{`${used} of ${total} used`}</span>
        </div>
        <Progress value={percentage} className="h-1"/>
      </div>
    </>
  );
};

export default ProgressUsage;
